import { render, staticRenderFns } from "./CombiInitialSituation.vue?vue&type=template&id=52e9271f"
import script from "./CombiInitialSituation.vue?vue&type=script&lang=ts"
export * from "./CombiInitialSituation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports